<header class="header">
    <nav class="top-navbar fixed-top d-flex justify-content-between">

        <div class="navbar-header d-flex align-items-center">
            <a (click)="expandMenu()" class="toggle-menu" [ngClass]="layoutService.expandedMenu ? 'show' : ''">
                <mat-icon>menu</mat-icon>
            </a>
            <a href="https://www.hartmann.info/app/InfectionPrevention/dashboard">
                <img class="app-logo" src="assets/img/app-logo.svg">
                <h1 class="app_name"><span>{{ translationKeys.LayoutModule.HeaderTitle | translate }}</span></h1>
            </a>
        </div>
        <ul class="nav-menu list-unstyled d-flex align-items-center">
            <!-- <li class="nav-item bdr-rgt  my-app-btn" (click)="helpMenu=false;notificationMenu=false;profileMenu=false;appMenu=true">
                <a class="nav-link"><img src="assets/ph-bhp-layout/svg/My%20Apps.svg"></a>
            </li> -->

            <!-- <li class="bdr-rgt assoc-app-btn" (click)="openServiceMenu()">
                <a class="nav-link">
                    <mat-icon>apps</mat-icon>
                </a>
            </li> -->

            <li class="assoc-app-btn" (click)="moveToTutorials()">
                <a class="nav-link">
                    <img
                        src="assets/ph-bhp-elearning/svg/icon-tutorial-header.svg"
                        alt="Imagen tutorial"
                        class="mx-auto d-block tutorial-size"
                  />
                </a>
            </li>

            <li class="assoc-app-btn" (click)="sendEmailToSupport()">
                <a class="nav-link">
                    <img
                        src="assets/ph-bhp-elearning/svg/icon-support-header.svg"
                        alt="Imagen tutorial"
                        class="mx-auto d-block support-size"
                  />
                </a>
            </li>

            <li class="assoc-app-btn">
                <a class="nav-link pr-0">
                    <div style="display: flex; align-items: center;">
                        <!-- <span class="img-lang-container mr-1" style="color: white !important;">
                            <mat-icon>language</mat-icon>
                        </span> -->
                        <span class="" >{{choosenlang.toUpperCase()}}</span>
                        <button (click)="toggleLangSelect()"
                            class="langSelectButton"><mat-icon>arrow_drop_down</mat-icon></button>
                        <div [@fadeInOut]="langSelectorVisible ? 'in' : 'out'" class="child-element">
                            <div id="" (click)="closeLangSelect()" class="langSelectBackDrop"></div>
                            <div id="" class="selectLanguageDiv">
                                <label class="changeLanguageLabel">{{'AUTHORIZATION.CHANGE_LANGUAGE' |
                                    translate}}</label>
                                <div class="langItemLabel" *ngFor="let option of optionsLang">
                                    <input [checked]="option.value == choosenlang" type="radio" name="group"
                                        (change)="selectLanguage(option.value)" class="langItem"
                                        [value]="option.language">
                                    <label class="langItemSpan" (click)="selectLanguage(option.value)">{{
                                        option.language | translate }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </a>
            </li>

            <!-- <li class="bdr-rgt assoc-app-btn" (click)="openContactMenu()">
                <a class="nav-link">
                    <mat-icon outline>headset_mic</mat-icon>
                </a>
            </li> -->

            <li class="nav-item usr-prof"
                (click)="openProfileMenu()">
                <a *ngIf=this.userData class="nav-link d-flex align-items-center">
                    <!-- <img src="assets/ph-bhp-layout/svg/User%20Profile.svg"> -->
                    <mat-icon outline>account_circle</mat-icon>
                    <span>
                        <span class="d-flex p-0 user-label">{{userData.name}}</span>
                        <span *ngIf="userData.roleName.roleId > 2" class="d-flex p-0 small institution-label"> {{selectedInstitution}} </span>
                    </span>
                    <img class="downArrow" src="assets/icons/arrowDropdownOutlined.svg">
                </a>
            </li>
            <li class="nav-item more-btn">
                <a class="nav-link"><img src="assets/ph-bhp-layout/svg/icon-more.svg"></a>
            </li>
        </ul>
    </nav>
</header>
<app-toast>toast</app-toast>
<lib-ph-bhp-sidepanel [showsidebar]="appMenu" (childData)="getEventAppMenu($event)">
    <div class="myapps-menu">
        <h3 class="page-title">{{ 'LAYOUT_MODULE.MY_APPS' | translate }}</h3>
        <!-- <div class="list-group mt-4">
            <a class="list-group-item list-group-item-action"><img
                    src="assets/ph-bhp-layout/svg/Observe.svg">{{ 'LAYOUT_MODULE.CARE_PRO' | translate }}</a>
            <a class="list-group-item list-group-item-action"><img
                    src="assets/ph-bhp-layout/svg/Consumption.svg">{{ 'LAYOUT_MODULE.HARTMANN_HYGIENE_PLATFORM' | translate }}</a>
        </div> -->
        <br>
        <h3 class="menu-title">{{ 'LAYOUT_MODULE.PH_APP_STORE' | translate }}</h3>
        <div class="list-group">
            <!-- <a class="list-group-item list-group-item-action"><img
                    src="assets/ph-bhp-layout/svg/icon-observe.svg">{{ 'DASHBOARD.OBSERVE' | translate }}</a> -->
            <a class="list-group-item list-group-item-action" (click)="openAppDownloadPopup(appStore)"><img
                    src="assets/ph-bhp-layout/svg/icon-SOP.svg">{{ 'AUTHORIZATION.MY_HYGIENE_SOP' | translate }}</a>
        </div>
    </div>
</lib-ph-bhp-sidepanel>

<lib-ph-bhp-sidepanel [showsidebar]="helpMenu" (childData)="getEventHelpMenu($event)">
    <div class="myapps-menu helpMenu">
        <h3 class="page-title">{{ 'LAYOUT_MODULE.HELP' | translate }}</h3>
        <iframe [src]="helpFileURL" height="100%" width="100%" class="my-3"></iframe>
        <!-- <iframe src="http://localhost:7013/!SSL!/index.htm" height="100%" width="100%" class="my-3"></iframe> -->
        <!-- <embed src="http://localhost:7013/!SSL!/index.htm"height="100%" width="100%" class="my-3"> -->
    </div>
</lib-ph-bhp-sidepanel>

<!-- <lib-ph-bhp-sidepanel [showsidebar]="notificationMenu" (childData)="getEventNotificationMenu($event)">
    <div class="myapps-menu">
        <h3 class="page-title">{{ 'LAYOUT_MODULE.NOTIFICATION' | translate }}</h3>
    </div>
</lib-ph-bhp-sidepanel> -->


<lib-ph-bhp-sidepanel [showsidebar]="profileMenu" (childData)="getEventProfileMenu($event)">
    <lib-ph-bhp-user-menu (childData)="menuChildData($event)" [userData]="userData" [institutions]="institutions">
    </lib-ph-bhp-user-menu>
</lib-ph-bhp-sidepanel>

<!-- <lib-ph-bhp-sidepanel [showsidebar]="contactMenu" (childData)="getEventContactMenu($event)">
    <ph-bhp-contact-menu (childData)="menuChildData($event)" [userData]="userData"
        [contactData]="contactData"></ph-bhp-contact-menu>
</lib-ph-bhp-sidepanel>

<lib-ph-bhp-sidepanel [showsidebar]="serviceMenu" (childData)="getEventServiceMenu($event)">
    <dhhp-appManager [platformURL]="platformURLDashboard" [princibleID]="loginID" [pinpoint]="pinpointURL"
        [endpoint]="adminEndpointAPI" [doShowDashboard]=true [apiSignature]="APISignature"
        (emitEvent)="onEmitEvent($event)"></dhhp-appManager>
</lib-ph-bhp-sidepanel> -->

<ng-template #appStore>
    <div class="modal-header">
        <h4 class="modal-title">{{ 'AUTHORIZATION.MY_HYGIENE_SOP' | translate }}</h4>
        <button type="button" class="close" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <p>{{ 'LAYOUT_MODULE.DOWNLOAD_TABLET_APPLICATION' | translate }}</p>
        <ul >
            <li >
                <a href='{{appUrl.androidUrl}}' target="_blank">
                    <img  src="assets/img/icons/android.png" alt="android">
                </a>
            </li>
            <li >
                <a href="{{appUrl.iosUrl}}" target="_blank">
                    <img src="assets/img/icons/apple.png" alt="apple">
                </a>
            </li>
        </ul>
    </div>
</ng-template>